module.exports = __webpack_public_path__ + "media/images/sports_icons/skateboarding-74486cbe66649b252cbe7e0ca9ac8b65.png";